export default __webpack_public_path__ + "static/media/28.c8934c6a.jpg";